export default "__VITE_ASSET__D1jJOS5w__"